package lacaravana.domain

import lacaravana.app.Database

data class MesaData(val id: Int, val numero: Int, val estado: String, val capacidad: Int)

object Mesa {
    suspend fun all(db: Database): List<MesaData> =
        db.query("SELECT id, numero, estado, capacidad FROM mesas ORDER BY numero").map { row ->
            MesaData(
                id = (row[0] as Number).toInt(),
                numero = (row[1] as Number).toInt(),
                estado = row[2] as String,
                capacidad = (row[3] as Number).toInt()
            )
        }

    suspend fun toggleEstado(db: Database, id: Int) {
        db.execute(
            "UPDATE mesas SET estado = CASE WHEN estado = 'libre' THEN 'ocupada' ELSE 'libre' END, updated_at = datetime('now') WHERE id = ?",
            arrayOf(id)
        )
    }

    suspend fun setEstado(db: Database, id: Int, estado: String) {
        db.execute(
            "UPDATE mesas SET estado = ?, updated_at = datetime('now') WHERE id = ?",
            arrayOf(estado, id)
        )
    }
}
